import { scrollIntoView } from 'seamless-scroll-polyfill';

export const scrollToHeroEnd = () => {
  if (typeof document !== 'undefined') {
    const heroSectionEnd = document.getElementsByClassName('hero-section-end');
    if (heroSectionEnd[0]) {
      // We use a polyfill for scrollIntoView() since recent versions of Safari
      // browsers have bugs in supporting the scroll behaviour.
      // See also: https://developer.apple.com/forums/thread/703294
      scrollIntoView(
        heroSectionEnd[0],
        { behavior: 'smooth' },
        { forcePolyfill: true },
      );
    }
  }
};

export const scrollToHash = () => {
  if (typeof document !== 'undefined') {
    // Delay the scroll for a bit, since sometimes the elements are not yet
    // rendered. This happens especially after a redirect (using gatsby
    // navigate) is done.
    setTimeout(() => {
      const hash = document.location.hash;
      if (hash === '') {
        return;
      }
      const hashElement = document.getElementById(hash.substring(1));
      if (hashElement) {
        // Same as in scrollToHeroEnd(), we use a polyfill for scrollIntoView()
        // since recent versions of Safari browsers have bugs in supporting the
        // scroll behaviour.
        // See also: https://developer.apple.com/forums/thread/703294
        scrollIntoView(
          hashElement,
          { behavior: 'smooth' },
          { forcePolyfill: true },
        );
      }
    }, 500);
  }
};
